const examData = [
    {
        examDate: "2025년 4월 23일",
        examName: "AITe 번역 시험",
        level: "전문 1급",
        registrationPeriod: "2025년 4월 1일 ~ 4월 20일"
    },
    {
        examDate: "2025년 5월 23일",
        examName: "프롬프트 번역 시험",
        level: "전문 2급",
        registrationPeriod: "2025년 5월 1일 ~ 5월 20일"
    },
    {
        examDate: "2025년 6월 23일",
        examName: "웹툰 번역 시험",
        level: "전문 3급",
        registrationPeriod: "2025년 6월 1일 ~ 6월 20일"
    },
    {
        examDate: "2025년 7월 23일",
        examName: "유튜브 번역 시험",
        level: "전문 1급",
        registrationPeriod: "2025년 6월 1일 ~ 6월 20일"
    }
];

export const ExamSchedule = () => {
    return (
        <section className={`flex-col text-left py-24 px-20 `}>
            <h1 className={`text-3xl`}>
                AITe 번역 일정</h1>
            <table className="min-w-full table-auto border-collapse border border-gray-300 mt-4">
                <thead>
                <tr className="bg-gray-200">
                    <th className="border px-4 py-2">시험일정</th>
                    <th className="border px-4 py-2">시험명</th>
                    <th className="border px-4 py-2">급수</th>
                    <th className="border px-4 py-2">접수 일정</th>
                </tr>
                </thead>
                <tbody>
                {examData.map((exam, index) => (
                    <tr key={index} className="border-b">
                        <td className="border px-4 py-2">{exam.examDate}</td>
                        <td className="border px-4 py-2">{exam.examName}</td>
                        <td className="border px-4 py-2">{exam.level}</td>
                        <td className="border px-4 py-2">{exam.registrationPeriod}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        
        </section>
    );
};
